<template lang="pug">
div
  slot
</template>

<script>
import config from "@/config";
import xhrMarket from "@/library/_xhr-market";
import xhrMatch from "@/library/_xhr-match";
import sync1 from "@/library/_sync-market";
import sync2 from "@/library/_sync-match";
import { EventBus } from "@/library/_event-bus.js";
import mixinTypes from "@/library/mixinTypes";

export default {
  mixins: [mixinTypes],
  data() {
    return {
      engine: null,
      turbo: null,
      state: {
        GET_BALANCE: 0,
        GET_MENU: 0,
        GET_MARKET: 0,
        GET_LIVE: 0,
        GET_NONLIVE: 0
      },
      limit: {
        GET_BALANCE: 20,
        GET_MENU: 20,
        GET_MARKET: 60,
        GET_LIVE: 10,
        GET_NONLIVE: 30
      },
      cache: null,
      oldTimer: null,
      hide: true,
      loading: {
        market: false,
        live: false,
        today: false,
        early: false,
        match2: false
      },
      marketTime: new Date(),
      liveTime: new Date(),
      todayTime: new Date(),
      earlyTime: new Date(),
      match2Time: new Date()
    };
  },
  computed: {
    housePower() {
      return this.$store.state.interval;
    },
    upcomingHours() {
      return this.$store.getters.upcomingHours;
    },
    isNonLive() {
      if (["all"].includes(this.menu0)) {
        if (["orz", "parlay"].includes(this.menu3)) {
          return true;
        } else {
          if (["early", "parlay"].includes(this.menu1)) {
            return true;
          }
        }
      } else {
        return false;
      }
      return false;
    },
    menu0() {
      return this.$store.getters.menu0;
    },
    menu1() {
      return this.$store.getters.menu1;
    },
    menu2() {
      return this.$store.getters.menu2;
    }
  },
  mounted() {
    console.log("engine mounted");
    EventBus.$on("GET_LIVE", this.runLive);
    EventBus.$on("GET_NONLIVE", this.runNonLive);
    EventBus.$on("GET_MARKET", this.runMarket);
    EventBus.$on("INVALIDATE", this.invalidate);
    this.startEngine();
  },
  destroyed() {
    console.log("engine destroyed");
    this.stopEngine();
    EventBus.$off("GET_LIVE", this.runLive);
    EventBus.$off("GET_NONLIVE", this.runNonLive);
    EventBus.$off("GET_MARKET", this.runMarket);
    EventBus.$off("INVALIDATE", this.invalidate);
  },
  methods: {
    invalidate() {
      this.state.GET_LIVE = 0;
      this.state.GET_NONLIVE = 0;
      this.state.GET_MARKET = 0;
    },
    runLive() {
      this.state.GET_LIVE = 0;
    },
    runNonLive() {
      this.state.GET_NONLIVE = 0;
    },
    runMarket() {
      this.state.GET_NONLIVE = 0;
      this.state.GET_LIVE = 0;
      this.state.GET_MARKET = 0;
    },
    startEngine() {
      this.runEngine();
      this.oldTimer = new Date();
    },
    runEngine() {
      this.engine = setTimeout(() => {
        if (this.isLoggedIn) {
          if (this.state.GET_MARKET > this.limit.GET_MARKET) {
            this.state.GET_MARKET = 0;
            this.state.GET_LIVE = 0;
            this.state.GET_NONLIVE = 0;
            EventBus.$emit("GET_MARKET");
          } else {
            this.state.GET_MARKET += 1;

            if (!this.isNonLive) {
              if (this.state.GET_LIVE > this.limit.GET_LIVE) {
                this.state.GET_LIVE = 0;
                EventBus.$emit("GET_LIVE");
              } else {
                this.state.GET_LIVE += 1;
              }
              EventBus.$emit("GET_LIVE_COUNT", this.limit.GET_LIVE + 1 - this.state.GET_LIVE);
            }

            if (this.state.GET_NONLIVE > this.limit.GET_NONLIVE) {
              this.state.GET_NONLIVE = 0;
              EventBus.$emit("GET_NONLIVE");
            } else {
              this.state.GET_NONLIVE += 1;
            }
            EventBus.$emit("GET_NONLIVE_COUNT", this.limit.GET_NONLIVE + 1 - this.state.GET_NONLIVE);
          }
          EventBus.$emit("GET_MARKET_COUNT", this.limit.GET_MARKET + 1 - this.state.GET_MARKET);
        } else {
          // this.$helpers.handleFeedback("invalidSession");
        }
        this.runEngine();
      }, this.housePower);
    },
    stopEngine() {
      clearTimeout(this.engine);
    },
    restartEngine() {
      this.stopEngine();
      this.startEngine();
    }
  }
};
</script>
